export const langRegister ={
    "arm":{
        tr_passwordDontMatch: "Գաղտնաբառը չի համընկնում",
        tr_pleaseFill: "Խնդրում եմ լրացնել դաշտերը",
        tr_passLengthValid: "Գաղտնաբառր պետք է ունենա մինիմում 8 սիմվոլ",
        tr_conferanceConnection: "Տեսակոնֆերենս կապ",
        tr_name: "Անուն",
        tr_lastName: "Ազգանուն",
        tr_email: "Էլ․ հասցե",
        tr_phone: "Հեռախոսահամար (միջազգային)",
        tr_phoneNumber: "Հեռախոսահամար",
        tr_selectCode: "Ընտրեք երկրի կոդը ցուցակից",
        tr_password: "Գաղտնաբառ",
        tr_repeatPass: "Կրկնել Գաղտնաբառը",
        tr_register: "Գրանցվել",
        tr_help: "Օգնություն",
        tr_logIn: "Մուտք գործել",
        tr_confSystem: "ՏԵՍԱՁԱՅՆԱՅԻՆ ԿՈՆՖԵՐԱՆՍ ԿԱՊԻ ՀԱՄԱԿԱՐԳ",
        tr_passDoesntMatch: "Գաղտնաբառը չի համընկնում",
        tr_verifyEmail: "Հաստատեք էլ․ հասցեն",
        tr_codeSentTo: "6-նիշանոց հաստատման կոդն ուղարկվել է",
        tr_code: "Հաստատման կոդ",
        tr_confirm: "Հաստատել",
        tr_resend: "Կրկին ուղարկել կոդը",
        tr_codeResent: "Նոր կոդն ուղարկված է",
        tr_back: "Հետ",
        tr_accountCreated: "Ձեր հաշիվը ստեղծվել է։ Կարող եք մուտք գործել։",
        errors: {
            NAME_REQUIRED: "Անունը և ազգանունը պարտադիր են",
            EMAIL_INVALID: "Էլ․ հասցեն սխալ է",
            PHONE_INVALID: "Հեռախոսահամարը սխալ է",
            PASSWORD_SHORT: "Գաղտնաբառր պետք է ունենա մինիմում 8 սիմվոլ",
            EMAIL_TAKEN: "Այս էլ․ հասցեով օգտատեր արդեն գրանցված է",
            PHONE_TAKEN: "Այս հեռախոսահամարով օգտատեր արդեն գրանցված է",
            RESEND_COOLDOWN: "Խնդրում ենք սպասել մեկ րոպե և նորից փորձել",
            EMAIL_SEND_FAILED: "Չհաջողվեց ուղարկել նամակը, փորձեք կրկին",
            CODE_EXPIRED: "Կոդի ժամկետը սպառվել է, գրանցվեք կրկին",
            CODE_WRONG: "Հաստատման կոդը սխալ է",
        },
    },
    "eng":{
        tr_passwordDontMatch: "The password does not match",
        tr_pleaseFill: "Please fill in the fields",
        tr_passLengthValid: "The password should have at least 8 characters",
        tr_conferanceConnection: "Video conference connection",
        tr_name: "Name",
        tr_lastName: "Last name",
        tr_email: "Email",
        tr_phone: "Phone number (international)",
        tr_phoneNumber: "Phone number",
        tr_selectCode: "Select a country code from the list",
        tr_password: "Password",
        tr_repeatPass: "Repeat the password",
        tr_register: "Register",
        tr_help: "Help",
        tr_logIn: "Log in",
        tr_confSystem: "VIDEO CONFERENCE COMMUNICATION SYSTEM",
        tr_passDoesntMatch: "Password does not match",
        tr_verifyEmail: "Verify your email",
        tr_codeSentTo: "A 6-digit verification code was sent to",
        tr_code: "Verification code",
        tr_confirm: "Confirm",
        tr_resend: "Resend code",
        tr_codeResent: "A new code has been sent",
        tr_back: "Back",
        tr_accountCreated: "Your account has been created. You can log in now.",
        errors: {
            NAME_REQUIRED: "Name and last name are required",
            EMAIL_INVALID: "Email is not valid",
            PHONE_INVALID: "Phone number is not valid",
            PASSWORD_SHORT: "The password should have at least 8 characters",
            EMAIL_TAKEN: "This email is already registered",
            PHONE_TAKEN: "This phone number is already registered",
            RESEND_COOLDOWN: "Please wait a minute and try again",
            EMAIL_SEND_FAILED: "Could not send the email, please try again",
            CODE_EXPIRED: "The code has expired, please register again",
            CODE_WRONG: "Wrong verification code",
        },
    },
    "fr":{
        tr_passwordDontMatch: "Mot de passe invalide",
        tr_pleaseFill: "Remplissez les champs requis",
        tr_passLengthValid: "Le mot de passe doit contenir au minimum 8 caractères",
        tr_conferanceConnection: "Connexion de vidéoconférence",
        tr_name: "Prénom",
        tr_lastName: "Nom",
        tr_email: "E-mail",
        tr_phone: "Numéro de téléphone (international)",
        tr_phoneNumber: "Numéro de téléphone",
        tr_selectCode: "Choisissez un indicatif pays dans la liste",
        tr_password: "Mot de passe",
        tr_repeatPass: "Répétez le mot de passe",
        tr_register: "Enregistrement",
        tr_help: "Aide",
        tr_logIn: "Identifiez-vous pour accéder",
        tr_confSystem: "SYSTÈME DE COMMUNICATION PAR VIDÉOCONFÉRENCE",
        tr_passDoesntMatch: "Le mot de passe ne correspond pas",
        tr_verifyEmail: "Vérifiez votre e-mail",
        tr_codeSentTo: "Un code de vérification à 6 chiffres a été envoyé à",
        tr_code: "Code de vérification",
        tr_confirm: "Confirmer",
        tr_resend: "Renvoyer le code",
        tr_codeResent: "Un nouveau code a été envoyé",
        tr_back: "Retour",
        tr_accountCreated: "Votre compte a été créé. Vous pouvez vous connecter.",
        errors: {
            NAME_REQUIRED: "Le prénom et le nom sont obligatoires",
            EMAIL_INVALID: "L'e-mail n'est pas valide",
            PHONE_INVALID: "Le numéro de téléphone n'est pas valide",
            PASSWORD_SHORT: "Le mot de passe doit contenir au minimum 8 caractères",
            EMAIL_TAKEN: "Cet e-mail est déjà enregistré",
            PHONE_TAKEN: "Ce numéro de téléphone est déjà enregistré",
            RESEND_COOLDOWN: "Veuillez patienter une minute et réessayer",
            EMAIL_SEND_FAILED: "Impossible d'envoyer l'e-mail, réessayez",
            CODE_EXPIRED: "Le code a expiré, veuillez vous réinscrire",
            CODE_WRONG: "Code de vérification incorrect",
        },
    },
    "arb":{
        tr_passwordDontMatch: "كلمة السرّ غير متطابقة",
        tr_pleaseFill: "يرجى ملء الحقول",
        tr_passLengthValid: "كلمة السرّ يجب أن يكون مؤلّفاً من 8 رموز على الأقلّ",
        tr_conferanceConnection: "المكالمة الجماعية عبر الفيديو",
        tr_name: "الاسم",
        tr_lastName: "اسم العائلة",
        tr_email: "البريد الإلكتروني",
        tr_phone: "رقم الهاتف (دولي)",
        tr_phoneNumber: "رقم الهاتف",
        tr_selectCode: "اختر رمز الدولة من القائمة",
        tr_password: "كلمة السرّ",
        tr_repeatPass: "إعادة كلمة السرّ",
        tr_register: "تسجيل",
        tr_help: "المساعدة",
        tr_logIn: "تسجيل الدخول",
        tr_confSystem: "نظام اتصالات مؤتمرات الفيديو",
        tr_passDoesntMatch: "كلمة المرور غير متطابقة",
        tr_verifyEmail: "تأكيد البريد الإلكتروني",
        tr_codeSentTo: "تم إرسال رمز تحقق مكوّن من 6 أرقام إلى",
        tr_code: "رمز التحقق",
        tr_confirm: "تأكيد",
        tr_resend: "إعادة إرسال الرمز",
        tr_codeResent: "تم إرسال رمز جديد",
        tr_back: "رجوع",
        tr_accountCreated: "تم إنشاء حسابك. يمكنك تسجيل الدخول الآن.",
        errors: {
            NAME_REQUIRED: "الاسم واسم العائلة مطلوبان",
            EMAIL_INVALID: "البريد الإلكتروني غير صالح",
            PHONE_INVALID: "رقم الهاتف غير صالح",
            PASSWORD_SHORT: "كلمة السرّ يجب أن يكون مؤلّفاً من 8 رموز على الأقلّ",
            EMAIL_TAKEN: "هذا البريد الإلكتروني مسجل بالفعل",
            PHONE_TAKEN: "رقم الهاتف هذا مسجل بالفعل",
            RESEND_COOLDOWN: "يرجى الانتظار دقيقة والمحاولة مرة أخرى",
            EMAIL_SEND_FAILED: "تعذر إرسال البريد الإلكتروني، حاول مرة أخرى",
            CODE_EXPIRED: "انتهت صلاحية الرمز، يرجى التسجيل مرة أخرى",
            CODE_WRONG: "رمز التحقق غير صحيح",
        },
    },
    "rus": {
        tr_passwordDontMatch: "Пароли не совпадают",
        tr_pleaseFill: "Пожалуйста, заполните поля",
        tr_passLengthValid: "Пароль должен содержать не менее 8 символов",
        tr_conferanceConnection: "Видеоконференцсвязь",
        tr_name: "Имя",
        tr_lastName: "Фамилия",
        tr_email: "Эл. почта",
        tr_phone: "Номер телефона (международный)",
        tr_phoneNumber: "Номер телефона",
        tr_selectCode: "Выберите код страны из списка",
        tr_password: "Пароль",
        tr_repeatPass: "Повторите пароль",
        tr_register: "Регистрация",
        tr_help: "Помощь",
        tr_logIn: "Войти",
        tr_confSystem: "СИСТЕМА ВИДЕОКОНФЕРЕНЦСВЯЗИ",
        tr_passDoesntMatch: "Пароли не совпадают",
        tr_verifyEmail: "Подтвердите эл. почту",
        tr_codeSentTo: "6-значный код подтверждения отправлен на",
        tr_code: "Код подтверждения",
        tr_confirm: "Подтвердить",
        tr_resend: "Отправить код ещё раз",
        tr_codeResent: "Новый код отправлен",
        tr_back: "Назад",
        tr_accountCreated: "Ваш аккаунт создан. Теперь вы можете войти.",
        errors: {
            NAME_REQUIRED: "Имя и фамилия обязательны",
            EMAIL_INVALID: "Неверный адрес эл. почты",
            PHONE_INVALID: "Неверный номер телефона",
            PASSWORD_SHORT: "Пароль должен содержать не менее 8 символов",
            EMAIL_TAKEN: "Этот адрес эл. почты уже зарегистрирован",
            PHONE_TAKEN: "Этот номер телефона уже зарегистрирован",
            RESEND_COOLDOWN: "Подождите минуту и попробуйте снова",
            EMAIL_SEND_FAILED: "Не удалось отправить письмо, попробуйте ещё раз",
            CODE_EXPIRED: "Срок действия кода истёк, зарегистрируйтесь заново",
            CODE_WRONG: "Неверный код подтверждения",
        },
    }
}
